export function ErrToStr(err: any): string {
	if (err instanceof Error && err.constructor?.name != "Error") {
		return `${err.constructor?.name}: ${err.message}`;
	}
	if (err instanceof Error) {
		return err.message;
	}
	return String(err);
}